var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CToaster',{attrs:{"position":"bottom-right"}},[_c('CToast',{key:'toast',class:_vm.notification.type,attrs:{"show":true,"header":_vm.headerText}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }